import { useCallback, useState } from 'react';
import { AlertFrequency, AlertType } from '../types';
import { useFundingRateAlerts } from './useFundingRateAlerts';

export function useCreateAlertForm(onCreated: () => void) {
	const { createAlert, canCreate } = useFundingRateAlerts();

	const [marketIndex, setMarketIndex] = useState<number | null>(null);
	const [marketSymbol, setMarketSymbol] = useState('');
	const [alertType, setAlertType] = useState<AlertType | null>(null);
	const [value, setValue] = useState('');
	const [frequency, setFrequency] = useState<AlertFrequency | null>(null);

	const isValid =
		marketIndex !== null &&
		alertType !== null &&
		value !== '' &&
		Number(value) > 0 &&
		frequency !== null &&
		canCreate;

	const reset = useCallback(() => {
		setMarketIndex(null);
		setMarketSymbol('');
		setAlertType(null);
		setValue('');
		setFrequency(null);
	}, []);

	const handleSubmit = useCallback(() => {
		if (
			marketIndex === null ||
			!alertType ||
			!frequency ||
			!value ||
			Number(value) <= 0
		)
			return;

		const success = createAlert({
			marketSymbol,
			marketIndex,
			alertType,
			thresholdPercent: Number(value),
			frequency,
		});

		if (success) {
			reset();
			onCreated();
		}
	}, [
		marketIndex,
		marketSymbol,
		alertType,
		value,
		frequency,
		createAlert,
		reset,
		onCreated,
	]);

	return {
		marketIndex,
		setMarketIndex,
		marketSymbol,
		setMarketSymbol,
		alertType,
		setAlertType,
		value,
		setValue,
		frequency,
		setFrequency,
		isValid,
		handleSubmit,
		reset,
	};
}
